function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 49,
  height: 49,
  stroke: "#2D577D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M38.2369 40.5387L42.5 38.0774L46.7631 40.5387V45.4613L42.5 47.9226L38.2369 45.4613V40.5387Z",
  stroke: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M28.2369 40.5387L32.5 38.0774L36.7631 40.5387V45.4613L32.5 47.9226L28.2369 45.4613V40.5387Z",
  className: "target",
  fill: "currentColor",
  fillOpacity: 0.5,
  stroke: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.2369 40.5387L22.5 38.0774L26.7631 40.5387V45.4613L22.5 47.9226L18.2369 45.4613V40.5387Z",
  stroke: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M8.23686 40.5387L12.5 38.0774L16.7631 40.5387V45.4613L12.5 47.9226L8.23686 45.4613V40.5387Z",
  stroke: "currentColor"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2369 31.5387L17.5 29.0774L21.7631 31.5387V36.4613L17.5 38.9226L13.2369 36.4613V31.5387Z",
  stroke: "currentColor"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M23.2369 31.5387L27.5 29.0774L31.7631 31.5387V36.4613L27.5 38.9226L23.2369 36.4613V31.5387Z",
  stroke: "currentColor"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M33.2369 31.5387L37.5 29.0774L41.7631 31.5387V36.4613L37.5 38.9226L33.2369 36.4613V31.5387Z",
  stroke: "currentColor"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M38.2369 22.5387L42.5 20.0774L46.7631 22.5387V27.4613L42.5 29.9226L38.2369 27.4613V22.5387Z",
  stroke: "currentColor"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M28.2369 22.5387L32.5 20.0774L36.7631 22.5387V27.4613L32.5 29.9226L28.2369 27.4613V22.5387Z",
  stroke: "currentColor"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M18.2369 22.5387L22.5 20.0774L26.7631 22.5387V27.4613L22.5 29.9226L18.2369 27.4613V22.5387Z",
  stroke: "currentColor"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M8.23686 22.5387L12.5 20.0774L16.7631 22.5387V27.4613L12.5 29.9226L8.23686 27.4613V22.5387Z",
  stroke: "currentColor"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M3.23686 13.5387L7.5 11.0774L11.7631 13.5387V18.4613L7.5 20.9226L3.23686 18.4613L3.23686 13.5387Z",
  stroke: "currentColor"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2369 13.5387L17.5 11.0774L21.7631 13.5387V18.4613L17.5 20.9226L13.2369 18.4613V13.5387Z",
  className: "target",
  fill: "currentColor",
  fillOpacity: 0.5,
  stroke: "currentColor"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M23.2369 13.5387L27.5 11.0774L31.7631 13.5387V18.4613L27.5 20.9226L23.2369 18.4613V13.5387Z",
  stroke: "currentColor"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M33.2369 13.5387L37.5 11.0774L41.7631 13.5387V18.4613L37.5 20.9226L33.2369 18.4613V13.5387Z",
  className: "target",
  fill: "currentColor",
  fillOpacity: 0.5,
  stroke: "currentColor"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M38.2369 4.53867L42.5 2.07735L46.7631 4.53867V9.46133L42.5 11.9226L38.2369 9.46133V4.53867Z",
  stroke: "currentColor"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M28.2369 4.53867L32.5 2.07735L36.7631 4.53867V9.46133L32.5 11.9226L28.2369 9.46133V4.53867Z",
  stroke: "currentColor"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M18.2369 4.53867L22.5 2.07735L26.7631 4.53867V9.46133L22.5 11.9226L18.2369 9.46133V4.53867Z",
  stroke: "currentColor"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M8.23686 4.53867L12.5 2.07735L16.7631 4.53867V9.46133L12.5 11.9226L8.23686 9.46133V4.53867Z",
  stroke: "currentColor"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M3.23686 31.5387L7.5 29.0774L11.7631 31.5387V36.4613L7.5 38.9226L3.23686 36.4613L3.23686 31.5387Z",
  className: "target",
  fill: "currentColor",
  fillOpacity: 0.5,
  stroke: "currentColor"
});

function SvgMultiTarget4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    className: "bg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiTarget4);
export default __webpack_public_path__ + "static/media/multiTarget-4.f0494ffa.svg";
export { ForwardRef as ReactComponent };